import React from "react";
import { t } from "ttag";

import type { NewsletterBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { H, HLevel } from "../Headings";
import { getThemeClass } from "../ThemedModule";
import { NewsletterForm } from "./NewsletterForm";
import { NewsletterSuccess } from "./NewsletterSuccess";

import styles from "./Newsletter.module.scss";

export const Newsletter = ({
    id,
    value,
}: {
    id?: string;
    value: NewsletterBlock;
}) => {
    const [isSubscribed, setIsSubscribed] = React.useState(false);
    const variant = value.variant?.[0];
    if (!variant) return null;

    const v = variant.value;

    const heading = v.heading && <H className={styles.heading}>{v.heading}</H>;
    const body = v.body && <p className={styles.body}>{v.body}</p>;

    return (
        <HLevel>
            <section
                className={concatClassNames([
                    styles.root,
                    variant.type === "media" ? styles.media : styles.callout,
                    getThemeClass(value.module_theme),
                ])}
            >
                {variant.type === "media" && variant.value.image && (
                    <div className={styles.imageWrapper}>
                        <ImageChooserBlock
                            value={variant.value.image}
                            attrs={{ className: styles.image }}
                        />
                    </div>
                )}
                <div className={styles.content}>
                    {heading}
                    {/* The body introduces the form, so it goes with it. */}
                    {isSubscribed ? (
                        <NewsletterSuccess
                            message={v.success_message ?? null}
                        />
                    ) : (
                        <>
                            {body}
                            <NewsletterForm
                                emailLabel={v.email_label ?? t`Email`}
                                consentLabel={v.consent_label ?? null}
                                submitLabel={v.submit_label ?? t`Subscribe`}
                                blockId={id}
                                onSuccess={() => setIsSubscribed(true)}
                            />
                        </>
                    )}
                </div>
            </section>
        </HLevel>
    );
};
